<template>
    <div class="main-questions">
        <div  v-for="question in allQuestions">
            <item-questions :question_item="question"></item-questions>
        </div>
    </div>

</template>

<script>
    import {mapState, mapGetters} from 'vuex'
    import axios from 'axios'
    import ItemQuestions from "./ItemQuestions.vue";
    export default {
        components: {ItemQuestions},
        name:'getAllQuestions',

        created:function () {
            this.getAllQuestions();
        },
        data() {
            return {
                showAnswers: true,
                questions: ''
            }
        },
        computed: {
            ...mapState,
            ...mapGetters([
                'allQuestions'
            ]),
            courseId () {
                return localStorage.getItem('mountedCourseId')
            }
        },
        methods: {
            getAllQuestions: function () {
                var url = '/api/v1/students/questions/getQuestions';
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    headers: {
                        token
                    },
                    mounted_courses_id: this.courseId
                }).then(response => {
                    this.$store.commit('questions', response.data);
                    /*this.questions = response.data*/

                });
            }
        }    
    }
</script>
<style scoped>
    .main-questions{
        display: flex;
        flex-direction: column;
    }
    .question-name{
        display:flex;
        flex-direction:row;
        background-color: white;
        border-radius: 5px;
        margin: 3px;
        width: 100%;
        align-content: center;
        justify-content: space-between;
        padding: 10px 10px 10px 10px;

        -webkit-box-shadow: 6px 6px 5px -7px rgba(194,194,194,1);
        -moz-box-shadow: 6px 6px 5px -7px rgba(194,194,194,1);
        box-shadow: 6px 6px 5px -7px rgba(194,194,194,1);
    }
</style>
